module.exports = __webpack_public_path__ + "img/Overview.7a165784.png";